import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {
  ref,
  toRefs,
  computed,
  watch,
  withDefaults,
  onMounted,
  nextTick
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import
vSelect,
{
  VueSelectProps
} from 'vue-select'
import { useIntersectionObserver, useDebounceFn } from '@vueuse/core'

interface IPropsSelectAsync extends Partial<VueSelectProps> {
  endpoint: string
  fieldValue?: string
  fieldLabel?: (item: any) => string
  searchFields?: Array<string>
  modelValue?: any
  searchCustom?: Array<any>
  id?: string
  classname?: string
  selectable?: (item: any) => boolean
  inputId: string
  placeholder: string
  disabled: boolean
  appendToBody?: boolean
  calculatePosition?: (dropdownList: any, component: any, pos: any) => void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAsync',
  props: {
    endpoint: { default: '' },
    fieldValue: { default: 'Id' },
    fieldLabel: { type: Function, default: () => 'Name' },
    searchFields: { default: () => [] },
    modelValue: { default: null },
    searchCustom: { default: () => [] },
    id: { default: '' },
    classname: { default: '' },
    selectable: { type: Function, default: () => true },
    inputId: { default: '' },
    placeholder: { default: 'Pilih' },
    disabled: { type: Boolean, default: false },
    appendToBody: { type: Boolean, default: false },
    calculatePosition: { type: Function, default: undefined }
  },
  emits: ["update:modelValue", "change", "search:focus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: any): void
  (e: 'change', val: any): void
  (e: 'search:focus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { endpoint: string, fieldValue: string, fieldLabel: (item: any) => string, searchFields: Array<string>, modelValue: any, searchCustom: Array<any>, id: string, classname: string, selectable: (item: any) => boolean, inputId: string, placeholder: string, disabled: boolean, appendToBody: boolean, calculatePosition: (dropdownList: any, component: any, pos: any) => void }





const {
  endpoint,
  fieldLabel,
  modelValue,
  inputId,
  placeholder,
  clearable,
  fieldValue,
  searchFields,
  searchCustom,
  id,
  selectable,
  classname,
  appendToBody,
  calculatePosition
} = toRefs(props)

const isLoading = ref(false)
const isLoadingMore = ref(false)
const options = ref([]) as any
const inputSearch = ref('')

const valueSelect = computed({
  get: () => modelValue?.value,
  set: (v) => {
    emit('update:modelValue', v)
  }
})
const hasNextPage = ref(false)
const load = ref<HTMLElement | null>(null)
const targetIsVisible = ref(false)
const pagination = {
  count: 0,
  pageNumber: 1,
  pageSize: 10,
  limit: 0
}

const selectableRow = (row: any) => selectable?.value(row)

// eslint-disable-next-line consistent-return
// const selectableRule = (val: any) => {
//   console.log('vall=>', val)
//   if (selectableParams.value.length > 0) {
//     if (lowerCase(selectableParams.value[1]) === 'equal') {
//       if (val[`${selectableParams.value[0]}`] === selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//     if (lowerCase(selectableParams.value[1]) === 'notequal') {
//       if (val[`${selectableParams.value[0]}`] !== selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//   }
//   return true
// }
let requestId = 0
const getData = async () => {
  const currentRequestId = ++requestId

  try {
    if (pagination.pageNumber === 1) {
      isLoading.value = true
    } else {
      isLoadingMore.value = true
    }

    const dropdownMenu = load.value?.closest('.vs__dropdown-menu')
    const scrollBefore = dropdownMenu?.scrollTop ?? 0

    const { result, error, count, pagenumber } = await apiUseCase.get(`${endpoint.value}${returnUrlPrams({
      search: inputSearch.value,
      filterField: searchFields.value,
      custom: searchCustom.value,
      pageNumber: pagination.pageNumber
    })}`)
    if (currentRequestId !== requestId) return

    if (!error) {
      if (pagenumber === 1) {
        pagination.limit = 0
        pagination.count = 0
        options.value = []
        // console.log('optionsreset', [inputSearch.value, options.value])
      }
      pagination.limit = count
      pagination.count += result.length
      // console.log([pagination.limit, pagination.count])
      if (pagination.count < pagination.limit) {
        hasNextPage.value = true
        pagination.pageNumber += 1
      } else {
        hasNextPage.value = false
      }

      // console.log('asadad', hasNextPage.value)
      // eslint-disable-next-line array-callback-return
      result.map((item: any) => {
        const data = {
          ...item,
          label: typeof fieldLabel.value === 'function' ? fieldLabel.value(item) : item[fieldLabel.value],
          value: item[fieldValue.value]
        }
        options.value.push(data)
      })
      // console.log('options', options.value)

      await nextTick()
      if (dropdownMenu) {
        dropdownMenu.scrollTop = scrollBefore
      }
    }
    isLoading.value = false
    isLoadingMore.value = false
  } catch (err) {
    isLoading.value = false
    isLoadingMore.value = false
  }
}

const onOpen = () => {
  // console.trace('OPENED')
  // console.log(document.activeElement)
  // console.trace()
  if (pagination.count === 0) {
    getData()
  }
  emit('search:focus')
}

const debounceSearch = useDebounceFn(() => {
  getData()
}, 800)

const onSearch = (val: any) => {
  // console.log('valSearch', val)
  if (val !== inputSearch.value) {
    isLoading.value = true
    pagination.pageNumber = 1
    options.value = []
    hasNextPage.value = false
    inputSearch.value = val
    debounceSearch()
  }
}

const { stop } = useIntersectionObserver(
  load,
  ([{ isIntersecting }]) => {
    targetIsVisible.value = isIntersecting

    if (targetIsVisible.value && !isLoadingMore.value) {
      getData()
    }
  },
  { rootMargin: '0px 0px 100px 0px' }
)

const optionSelected = (select: any) => {
  // console.log('selec', select)
  emit('change', select)
}

watch(valueSelect, (val: any) => {
  // console.log('WATCH VALUE', val)
  // console.log('val', val)
  if (!val) {
    emit('change', val)
  }
})

onMounted(async () => {
  await nextTick()

  setTimeout(() => {
    const active = document.activeElement as HTMLElement

    if (active?.classList.contains('vs__search')) {
      active.blur()
    }
  }, 0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(vSelect), {
    class: _normalizeClass(`select-default ${_unref(classname)}`),
    inputId: _unref(inputId),
    placeholder: _unref(placeholder),
    clearable: _unref(clearable),
    id: _unref(id),
    disabled: __props.disabled,
    options: _unref(options),
    modelValue: _unref(valueSelect),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSelect) ? (valueSelect).value = $event : null)),
    onOpen: onOpen,
    onSearch: onSearch,
    selectable: selectableRow,
    "onOption:selected": optionSelected,
    "onOption:deselecting": optionSelected,
    loading: isLoading.value,
    autofocus: false,
    "append-to-body": _unref(appendToBody),
    "calculate-position": _unref(calculatePosition)
  }, {
    "list-footer": _withCtx(() => [
      (hasNextPage.value || isLoadingMore.value)
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            ref_key: "load",
            ref: load,
            class: "loader"
          }, [
            (isLoadingMore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Sedang memuat..."))
              : _createCommentVNode("", true)
          ], 512))
        : _createCommentVNode("", true)
    ]),
    "no-options": _withCtx(({ searching, loading }) => [
      searching
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Tidak ada data ditemukan. "))
        : _createCommentVNode("", true),
      loading
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Tidak ada data ditemukan. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "inputId", "placeholder", "clearable", "id", "disabled", "options", "modelValue", "loading", "append-to-body", "calculate-position"]))
}
}

})